import type { DataItem as BookedJobsTableDataItem } from '@/components/tables/BookedJobsTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { formatInTimeZone } from 'date-fns-tz';

import { getStrCell } from '@/utils/file';
import * as commonConstants from '@/constants/common';

export type BookedJob =
  openapi.GetDashboardBookingUserLog_200['results'][number];

function getCreatedAt(date: string | undefined, timeZone: string): string {
  if (!date) return commonConstants.EM_DASH;
  try {
    return formatInTimeZone(date, timeZone, 'yyyy-MM-dd HH:mm:ss');
  } catch {
    return commonConstants.EM_DASH;
  }
}

export function getTableItem(
  job: BookedJob,
  userTimeZone: string,
): BookedJobsTableDataItem {
  return {
    uniqueKey: job.id.toString(),
    jobId: job.rockhopper_id,
    jobDate: job.rockhopper_date,
    source: getStrCell(job.source_text),
    status: getStrCell(job.status),
    createdBy: getStrCell(job.created_by),
    createdAt: getCreatedAt(job.created_at, userTimeZone),
    fold: {
      logId: job.id,
    },
  };
}
